import styled from 'styled-components'

import {Box, Inline, Text, tokens} from '@pleo-io/telescope'

import {Accordion} from '~/generic-ui/accordion'
import {WistiaVideo} from '~/generic-ui/wistia-video'

export const Container = styled(Box)`
    text-align: left;
`

export const BackButtonWrapper = styled(Inline)`
    position: sticky;
    top: 0;
    background-color: ${tokens.shade000};
`

export const BackAction = styled(Text).attrs({color: 'colorContentInteractiveLink'})`
    cursor: pointer;
`
export const Title = styled.p`
    font-size: ${tokens.font2XLarge};
    font-weight: ${tokens.fontWeightRegular};
    line-height: ${tokens.lineHeight2};
`

export const StyledAccordionItem = styled(Accordion.Item)`
    border: none;
    border-top: ${tokens.borderPrimary};
    border-radius: 0;
    display: flex;
    flex-direction: column;

    &:first-child {
        border-top: none;
    }
`

export const StyledHeader = styled(Accordion.Header)`
    ${Accordion.Trigger} {
        [data-state='closed'] & {
            border-radius: 0;
        }
    }
`

export const StyledAccordionContent = styled(Accordion.Content)`
    overflow-y: auto;
`

export const StyledWistiaVideo = styled(WistiaVideo)`
    > div {
        width: 100% !important;
    }

    & img {
        width: 100%;
    }
`
